import React from 'react';

const SafetyDisclaimer = () => {
  return (
    <div style={{
      background: 'rgba(248,113,113,0.05)', border: '1px solid rgba(248,113,113,0.2)',
      borderRadius: '8px', padding: '16px 24px', marginBottom: '24px',
      display: 'flex', alignItems: 'flex-start', gap: '16px',
    }}>
      <span style={{ fontSize: '20px' }}>⚠️</span>
      <div>
        <p style={{ color: '#f87171', fontWeight: 600, fontSize: '13px', letterSpacing: '0.04em' }}>Safety Notice</p>
        <p style={{ color: 'var(--text-muted)', fontSize: '12px', marginTop: '4px', lineHeight: 1.6 }}>
          Please exercise caution when visiting properties or meeting sellers in person. Verify identities, visit during daylight hours, and inform someone of your whereabouts. <strong style={{ color: '#f87171' }}>One Stop Shop is not liable for any theft, injury, or harm</strong> that may occur during property visits or transactions.
        </p>
      </div>
    </div>
  );
};

export default SafetyDisclaimer;